import React from 'react'

import { Box, Typography } from "@mui/material"
import { AppValueChip } from "@components"


export default function acrissColumn() {

	return {
		name: 'acriss',
		label: 'ACRISS Code',
		options: {
			filterType: 'textField',
			customBodyRowRenderLite: value => <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
				{value ? <AppValueChip tone="accent" sx={{ fontWeight: 600 }}>{value}</AppValueChip> : <Typography>Any</Typography>}
			</Box>,
		}
	}
}